<template>
  <Btn :label="$t('ELE0504')" icon="mdi-history" @click="onClick" :disabled="disabled" />
</template>

<script>
import Btn from '@/components/atoms/base/button/Btn'

export default {
  name: 'BtnHistoryOpen',

  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  components: {
    Btn,
  },

  methods: {
    onClick() {
      this.$emit('click')
    },
  },
}
</script>
